// Construcción de la búsqueda de dirección para el geocoder: aislada acá
// para no dispersar concatenaciones de dirección por los componentes de
// React. La UI llama a la API propia de Lynx (GET /v2/deliveries/geo/search,
// ver GeoResolutionPanel) — nunca a un proveedor externo directamente. El
// backend decide qué proveedor usa (hoy LocationIQ); esto no lo sabe.
//
// Regla de negocio: la búsqueda usa SOLO dirección + CP operativo efectivo
// + localidad + provincia. Nunca observaciones ni nada específico del
// provider de origen (ML/Tiendanube/WooCommerce/carga manual): Lynx
// geolocaliza la ENTIDAD Delivery, no una integración en particular.

export type GeocodeAddressInput = {
  direccion?: string | null;
  codigoPostal?: string | null;
  localidad?: string | null;
  provincia?: string | null;
};

/** CP operativo efectivo: el confirmado por Lynx si existe, si no el recibido. */
export function effectivePostalCode(
  codigoPostal?: string | null,
  confirmedPostalCode?: string | null
): string {
  return (confirmedPostalCode || codigoPostal || "").trim();
}

/** Solo para mostrarle al operador qué se va a buscar, ej: "San Martín 1250, 1706, Haedo, Buenos Aires". */
export function buildGeocodeQuery({
  direccion,
  codigoPostal,
  localidad,
  provincia,
}: GeocodeAddressInput): string {
  return [direccion, codigoPostal, localidad, provincia]
    .map((v) => (v ?? "").trim())
    .filter(Boolean)
    .join(", ");
}

export type GeocodeConfidenceLevel = "high" | "medium" | "low";

/** Ver server/current/delivery/geocoding/confidence.js — se calcula server-side,
 * esta pantalla solo la pinta (nunca la recalcula). */
export type GeocodeConfidence = {
  level: GeocodeConfidenceLevel;
  reasons: string[];
};

/** Contrato propio de Lynx para un candidato del geocoder — nunca la respuesta cruda del proveedor
 * (ver server/current/delivery/geocoding/geocodeService.js). */
export type GeocodeCandidate = {
  latitude: number;
  longitude: number;
  displayName: string | null;
  address: string | null;
  postalCode: string | null;
  locality: string | null;
  province: string | null;
  providerMetadata: Record<string, unknown> | null;
  confidence: GeocodeConfidence;
};
